<script>
  import getSecret from '@utils/get-secret'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'
  import BaseDatatable from '@components/base-datatable'
  import {
    euroPaylessLogsMethods,
  } from '@state/helpers'
  import ThirdpartyMultiselect from '@components/euro_coupons/thirdparty/Select'
  import CustomDatePickerRange from '@components/CustomDatePickerRange'
  import CustomMultiselect from '@/src/components/CustomMultiselect.vue'
  import FormSelect from '@/src/components/form/Select.vue'
  import SelectMultipleSearch from '@/src/components/form/SelectMultipleSearch.vue'
  import downloadModal from '@/src/components/reports/management/modalDownload.vue'
  import ActionButton from '@components/buttons/ActionButton.vue'
  import ModalDetail from '@/src/components/reports/management/modalDetail.vue'
  
  export default {
    name: 'Reportes',
    page: {
      title: 'Reportes',
      meta: [{ name: 'Reportes', content: getSecret('DESCRIPTION') }],
    },
    components: {
      Layout,
      PageHeader,
      BaseDatatable,
      ThirdpartyMultiselect,
      CustomDatePickerRange,
      CustomMultiselect,
      FormSelect,
      downloadModal,
      ActionButton,
      ModalDetail,
      SelectMultipleSearch,
      EuroPaylessLogDetail: () => import('@components/reports/management/modalLogPayless'),
    },
    data() {
      return {
        title: this.$t('Logs API Payless'),
        items: [
          {
            text: this.$t('home'),
            href: '/',
          },
          {
            text: this.$t('Logs API Payless'),
            active: true,
          },
        ],
        loadingReport: false,
        tableHeaders: [],
        toDetail: {},
        showDetail: false,
        filterset: null,
        filters: {
          created_at__gte: null,
          created_at__lte: null,
        },
        filtersDate:{
          fecha__gte:null,
          fecha__lte:null,
        },
        showDownload: false,
        flagDate: true,
      }
    },
  
    mounted() {
    },
  
    beforeMount() {
      this.tableHeaders = [
          { key: 'order_id', label: this.$t('Order ID') },
          { key: 'barcode', label: this.$t('Codigo de Pago') },
          { key: 'status_code', label: this.$t('Status Code') },
          { key: 'error', label: this.$t('Error') },
          { key: 'created_at', label: this.$t('Fecha') },
          { key: 'actions', label: this.$t('actions') },
      ]
    },
  
    watch: {
      filters: {
        deep: true,
        handler(filters) {
          let filters_list = []
          for (let filter in filters) {
            if (filters[filter]) {
              filters_list.push(`${filter}=${filters[filter]}`)
            }
          }
          if (filters_list.length) {
            this.filterset = filters_list.join('&')
          }
          this.filter()
        },
      },
    },
  
    methods: {
      ...euroPaylessLogsMethods,
      myProvider(ctx) {
        let context = this
        ctx = context.$table_params(ctx)
        ctx += context.filterset ? `&${context.filterset}` : ''
        const promise = context.fetchEuroPaylessLogs(ctx)
        return promise
          .then((data) => {
            return data
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            console.log(error)
            return []
          })
      },
      setFilter(filter, value) {
        if(value!=null){
          this.filters[filter] = value
        }
      },
  
      filter() {
        this.$refs.table.lastFilter = ''
        this.$refs.table.onFiltered()
        setTimeout(() => this.$refs.table.refresh(), 200)
      },
  
      clear() {
        this.filters.created_at__gte = null
        this.filters.created_at__lte = null
        this.filtersDate.created_at__gte=null
        this.filtersDate.created_at__lte=null
        this.flagDate = !this.flagDate
        this.filterset = null
        setTimeout(() => this.$refs.table.refresh(), 200)
      },
    },
  }
  </script>
  
  <template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <b-container fluid class="p-0">
        <b-row>
          <b-col>
            <b-card class="shadow-sm">
              <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
                <b>{{ $t('filters') }}</b>
              </b-row>
              <b-row>
                <b-col md="3" class="p-0" style="margin: 0 1rem 0 0">
                  <b-col>
                    <CustomDatePickerRange
                      label='Fecha'
                      :flag="flagDate"
                      :value_start="filtersDate.created_at__gte"
                      :value_end="filtersDate.created_at__lte"
                      @input_start="
                        (value) => value!=null ? setFilter('created_at__gte', value+' 00:00:00') : filtersDate.created_at__gte=null
                      "
                      @input_end="
                        (value) => value!=null ? setFilter('created_at__lte', value+' 23:59:59') : filtersDate.created_at__lte=null
                      "
                    />
                  </b-col>
                </b-col>
                <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">
                  <b-button
                    class="rounded shadow-sm float-right"
                    variant="outline-primary"
                    @click="clear"
                    ><i class="fas fa-eraser"></i>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card class="shadow">
              <BaseDatatable
                ref="table"
                :drfprovider="myProvider"
                :tableheaders="tableHeaders"
                :key="filters.created_at__gte && filters.created_at__lte"
                :filterOption="true"
              >
                <template v-slot:cell(id_order)="row">
                  {{row.item.id_order}}
                </template>
                <template v-slot:cell(status_code)="row">
                  {{row.item.status_code}}
                </template>
                <template v-slot:cell(error)="row">
                  {{row.item.error ? 'Error' : ''}}
                </template>
                <template v-slot:cell(created_at)="row">
                  {{(row.item.created_at).slice(0,16).replace('T',' ')}}
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button-group size="xs">
                    <b-button
                      :id="`info-btn-${row.index}`"
                      v-b-tooltip.hover="{
                        variant: 'info',
                        placement: 'leftbottom',
                        title: $t('detail'),
                      }"
                      variant="btn-link text-info btn-transparent"
                      size="xs"
                      @click="()=>{showDetail=true; toDetail=row.item}"
                    >
                      <i
                        class="fe-info fe-2x"
                      ></i>
                    </b-button>
                  </b-button-group>
                </template>
              </BaseDatatable>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
  
      <EuroPaylessLogDetail
        v-if="showDetail"
        :instanceJson="toDetail || {}"
        :oncancel="
          () => {
            showDetail = false;
            toDetail = {}
          }
        "
      >
      </EuroPaylessLogDetail>
    </Layout>
  </template>
  